<template>
    <div>
        <template v-if="layerData">
            <!-- 河湖岛工程 -->
            <LFeature ref="heHuIslAndProjectFeature" :wktString="layerData.geometry" :id="layerData.id"
                :featureStyle="getlayerStyle"></LFeature>
            <LOverLay v-if="overlayVisible" :position="overlayPosition" :zIndex="100">
                <el-popover ref="popover" v-model="popoverVisible" trigger="click" popper-class="c-el-popover-blue"
                    placement="right-end" @hide="overlayVisible = false">
                    <div ref="popoverRef" slot="reference"></div>
                    <hzItemDetailsPop :itemObj="layerData" :border="false" />
                </el-popover>
            </LOverLay>
        </template>
    </div>
</template>

<script>

import { OMapMixin, LFeature, LOverLay } from '@OpenLayersCommon';
import { Fill, Style, Stroke, Text } from 'ol/style';
import { getCenter } from 'ol/extent';
import { WKT } from 'ol/format';
import hzItemDetailsPop from '@/page/business/hezhang/components/hzItemDetailsPop.vue';

const WktInstance = new WKT();
export default {
    mixins: [OMapMixin],
    components: {
        LFeature,
        LOverLay,
        hzItemDetailsPop,
    },
    props: {
        activityObj: {
            type: Object,
            default () {
                return {};
            },
        },

        layerData: {
            type: Object,
            default () {
                return {};
            },
        },

    },

    data () {
        return {
            gridExtent: null,
            overlayVisible: false,
            popoverVisible: false,
            mapZoom: 12,
        };
    },
    watch: {
        layerData: {
            handler (newVal, oldVal) {

            },
            deep: true,
            immediate: true,
        },
        activityObj: {
            handler (newVal) {
                console.log('activityObj', newVal);
                if (this.$refs.heHuIslAndProjectFeature) {
                    // 1. 获取 LFeature 内部的 OpenLayers 要素
                    const olFeature = this.$refs.heHuIslAndProjectFeature.mapComponent;
                    // 2. 计算新样式
                    const newStyle = this.getlayerStyle();
                    // 3. 直接调用 OpenLayers 原生方法更新样式（绕过组件监听，最可靠）
                    if (olFeature) {
                        olFeature.setStyle(newStyle);
                        // 4. 强制地图重绘（极端情况）
                        if (this.$map) {
                            this.$map.render();
                        }
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {

        overlayPosition () {
            let position = null;
            if (this.gridExtent) {
                position = getCenter(this.gridExtent);
            }

            // this.$map && this.$map.getView().fit(position, this.$map.getSize());
            return position;
        },

    },
    methods: {
        getlayerStyle () {
            let layerData = this.layerData || {};
            let activityObj = this.activityObj || {};
            const isSelected = layerData.id === activityObj.id; // 提取选中状态变量，提高可读性
            console.log('isSelected', isSelected);

            let textString = layerData.name;

            const normalFillColor = `${this.getColor(layerData.type || 'PROJECT')}40`; // 确保透明度格式正确
            const normalStrokeColor = this.getColor(layerData.type || 'PROJECT');
            const normalStrokeWidth = 2;

            // 选中时文字颜色变化
            const text = new Text({
                text: textString,
                font: 'bold 14px Microsoft YaHei',
                fill: new Fill({ color: normalStrokeColor }),
                stroke: new Stroke({
                    color: '#ffffff',
                    width: isSelected ? 2 : 1.5, // 选中时文字描边更粗
                }),
                overflow: true,
                textBaseline: 'middle',
                textAlign: 'center',
                placement: 'center',
            });

            // 选中时的特殊样式
            const selectedFillColor = `${normalStrokeColor}98`; // 增加透明度，更适合填充色
            // 未选中时的样式

            return new Style({
                fill: new Fill({
                    color: isSelected ? selectedFillColor : normalFillColor,
                }),
                stroke: new Stroke({
                    color: normalStrokeColor,
                    width: normalStrokeWidth,
                }),
                text,
            });
        },
        showPopover () {
            this.overlayVisible = true;
            setTimeout(() => {
                if (this.$refs.popoverRef) {
                    this.popoverVisible = true;
                }
            }, 100);
        },
        /**
         * 这个方法必须，因为LFeature 组件初始化时会调用mixin 中的getParentComponent方法去获取ol.layer.Vector实例
         * 现在LFeature 组件是在当前组件的子组件中，所以LFeature的父组件不再是LVector 而是当前组件
         * 所以需要重写这个方法，返回Vector 的实例
         *
         */
        getComponent () {
            return this.$parent.getComponent();
        },

        /**
         * 获取数据的范围
         *
         * @returns {import("ol/extent").Extent} 返回数据的范围
         */
        getExtent () {
            let extent = null;
            if (this.layerData) {
                const wktString = this.layerData.geometry;
                if (wktString) {
                    const feature = WktInstance.readFeature(wktString);
                    extent = feature.getGeometry().getExtent();
                }
            }
            this.gridExtent = extent;
            return extent;
        },
        async initMap () {
            const map = await this.getMap();
            this.$map = map;
            if (map) {
                map.on('moveend', this.handleOnMapMoveEnd);
                this.mapZoom = map.getView().getZoom();
                map.getView().on('change:resolution', this.handleZoomChange);
            }
        },
        handleOnMapMoveEnd () {
            if (this.$refs.popover) {
                this.$refs.popover.updatePopper();
            }
        },
        handleZoomChange () {
            this.mapZoom = this.$map.getView().getZoom();
        },
        getColor (type) {
            switch (type) {
                case 'RIVER':
                    return '#449CF6';
                case 'LAKE':
                    return '#00FFBF';
                case 'ISLAND':
                    return '#20A41E';
                case 'PROJECT':
                    return '#FFC300';
                default:
                    return '#449CF6';
            }
        },

    },
    mounted () {
        this.getExtent();
        this.initMap();
    },
    beforeDestroy () {
        const map = this.$map;
        if (map) {
            map.un('moveend', this.handleOnMapMoveEnd);
            map.getView().un('change:resolution', this.handleZoomChange);
        }
    },
};
</script>

<style lang="scss" scoped></style>
<style lang="scss">
$blueLight: #49f0fd;

.grid-popover-text {
    color: $blueLight;
}
</style>
